<template>
  <div class="local-options-style">
    <div class="setting-item clearFloat">
      <el-popover
        ref="previewPopover"
        popper-class="previewPopover"
        placement="left"
        title=""
        trigger="hover"
        :visible-arrow="false"
        :disabled="disablePreview"
      >
        <img style="width: 100%; height: 100%" :src="previewSrc" />
        <div slot="reference" class="content">
          <swiper :options="swiperOptions">
            <swiper-slide v-for="idx in swiperLen" :key="idx">
              <ul class="local-styles">
                <li
                  class="local-style-item"
                  v-for="(style, index) in localStyles.slice(
                    showLen * (idx - 1),
                    showLen * idx > localStyles.length ? localStyles.length : showLen * idx
                  )"
                  :class="
                    (style.styleId && style.styleId === options.styleId) ||
                    (style.options.styleId && style.options.styleId === options.styleId) ||
                    (style.options.chartOption &&
                      style.options.chartOption.styleId &&
                      style.options.chartOption.styleId === options.chartOption.styleId)
                      ? 'active'
                      : ''
                  "
                  :key="index"
                >
                  <div
                    class="local-img-box"
                    @click="changeLocalStyle(style, index, idx)"
                    @mouseenter="setMouseEnter"
                    @mouseout="setMouseOut"
                  >
                    <img :src="styleImgs[showLen * (idx - 1) + index]" alt="" />
                    <span class="checked-box" v-if="request_prefix !== 'bigScreen'">
                       <i class="icon-checked"></i>
                    </span>
                  </div>
                  <p class="fs14 overflowHid1">样式{{ showLen * (idx - 1) + index + 1 }}</p>
                </li>
              </ul>
            </swiper-slide>
          </swiper>
          <div class="swiper-button swiper-button-prev" v-if="localStyles.length > showLen"></div>
          <div class="swiper-button swiper-button-next" v-if="localStyles.length > showLen"></div>
        </div>
      </el-popover>
    </div>
    <styles-list
      v-if="showAllStyle"
      :showDialog.sync="showAllStyle"
      :typeId="typeId"
      :styleTypeName="styleTypeName"
      :allStyles="localStyles"
      :styleImgs="styleImgs"
      styleType="local"
      :options="options"
      :activeIndex="activeIndex"
      :localStylesLen="localStyles.length"
      @changeStyle="changeLocalStyle"
    ></styles-list>
  </div>
</template>

<script>
import instance from "../../../interceptor"
import stylesList from "./styles-list"
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper"
import "swiper/css/swiper.min.css"
import { getSyetemModuleJson } from "@/utils/initEv.js"
import { hidePreviewStyle } from "@/utils"

export default {
  name: "local-style",
  components: {
    stylesList,
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  props: {
    options: {
      type: Object,
      required: true
    },
    elementType: {
      type: String
    },
    styleImgs: {
      type: Array
    }
  },
  computed: {
    typeId() {
      return this.options.componentTypeId
    },
    localStyles() {
      let menu =
        this.request_prefix === "bigScreen"
          ? this.$store.state.bigScreenMenu.menu
          : this.request_prefix === "appStage"
          ? this.$store.state.appMenu.menu
          : this.$store.state.menu.menu
      let styles = [],
        localStyles = []

      const styleObj = this.materialLoader.getMenuChildByTypeOrName({
        type: this.elementType,
        name: this.options.name,
        stageType: this.request_prefix,
      })
      if (styleObj && this.options.menuName !== "登录组件") {
        styles = styleObj.children
        this.styleTypeName = styleObj.name
      } else {
        for (let i = 0; i < menu.children.length; i++) {
          for (let j = 0; j < menu.children[i].children.length; j++) {
            if (
              menu.children[i].children[j].type === this.elementType ||
              menu.children[i].children[j].name === this.options.menuName
            ) {
              styles = menu.children[i].children[j].children
              this.styleTypeName = menu.children[i].children[j].name
              break
            }
          }
        }
      }
      styles.forEach((item, index) => {
        // localStyles.push(item.attribute.options)
        localStyles.push(item.attribute)
      })
      return localStyles
    },
    showStyles() {
      return this.localStyles.length > this.showLen ? this.localStyles.slice(0, this.showLen) : this.localStyles
    },
    swiperLen() {
      return Math.ceil(this.localStyles.length / this.showLen)
    }
  },
  data() {
    return {
      activeIndex: 0,
      activeNames: [],
      showLen: 4,
      styleTypeName: "",
      showAllStyle: false,
      swiperOptions: {
        loop: false,
        speed: 500,
        autoplay: false,
        navigation: {
          nextEl: ".swiper-button.swiper-button-next",
          prevEl: ".swiper-button.swiper-button-prev"
        }
      },
      previewSrc: "",
      disablePreview: true
    }
  },
  methods: {
    showAllStyles() {
      this.showAllStyle = true
    },
    async changeproductStyle(style, index, idx) {
      if (typeof index !== undefined) {
        if (idx) {
          this.activeIndex = this.showLen * (idx - 1) + index
        } else {
          this.activeIndex = index
        }
      }
      let tmpData
      let curOptions = this.$getOptions()
      if (!style.componentTypeId) {
        // 请新求回来的数据没有添加初始配置
        style.componentTypeId = curOptions.componentTypeId
        style.componentTypeName = curOptions.componentTypeName
      }
      if (!style.isDefaultComponent) {
        // 上传到服务器的系统样式
        const _attribute = await getSyetemModuleJson(style.encId)
        tmpData = _attribute.options
        tmpData.rect_id = _attribute.rect_id
        tmpData.shape = _attribute.shape
        tmpData.isSystemComponent = true
        tmpData.isIndependenceComponent = style.type === "swiperComponent" ? false : true
        tmpData.componentTypeId = style.componentTypeId
        tmpData.componentTypeName = style.componentTypeName
        tmpData.encId = style.encId
        tmpData.name = style.name
        tmpData.isDefaultComponent = false
      } else {
        // 本地默认样式
        tmpData = JSON.parse(JSON.stringify(style))
      }
      let ids = this.$store.state.states.activeID
      let oldHeight = tmpData.height
      tmpData.left = curOptions.left
      tmpData.leftType = curOptions.leftType
      tmpData.top = curOptions.top
      tmpData.topType = curOptions.topType
      tmpData.margin = curOptions.margin
      tmpData.offset = curOptions.offset
      tmpData.isQuickSite = curOptions.isQuickSite
      // 按钮想要保存新样式的尺寸
      if (curOptions.appId) {
        tmpData.width = curOptions.width
        tmpData.widthType = curOptions.widthType
        tmpData.height = curOptions.height
        tmpData.heightType = curOptions.heightType
      }
      // 针对登录按钮，保留部分属性
      if (curOptions.loginType) {
        tmpData.loginType = curOptions.loginType
        tmpData.content = curOptions.content
        tmpData.iconSrc = curOptions.iconSrc
        tmpData.iconType = curOptions.iconType
      }
      //自由布局组件在切换样式的时候保证外接数据源和原来的一致 刘娅的需求
      if (curOptions.innerElement.toLowerCase().includes("layout")) {
        tmpData.appId = curOptions.appId
        tmpData.moduleId = curOptions.moduleId
        tmpData.myFetchParam = curOptions.myFetchParam
        // 还需要把列表页、详情页id带过去，不然后会造成重复创建子页面
        tmpData.detailPageId = curOptions.detailPageId
        tmpData.detailPageTemplateEncId = curOptions.detailPageTemplateEncId
        tmpData.listPageId = curOptions.listPageId
        tmpData.listPageTemplateEncId = curOptions.listPageTemplateEncId
      }
      // 导航菜单在切换样式的时候保证外接数据源和原来的一致 不然跳数据中心报错
      if (curOptions.innerElement == "cxNavMenu") {
        tmpData.appId = curOptions.appId
        tmpData.moduleId = curOptions.moduleId
        tmpData.myFetchParam = curOptions.myFetchParam
      }
      // 切换样式保持应用名称不变 美多需求
      tmpData.name = curOptions.name
      tmpData.menuName = curOptions.menuName
      tmpData.menuIconClass = curOptions.menuIconClass
      let data = {
        ...ids,
        options: tmpData
      }
      this.$store.dispatch(this.request_prefix + "/changeAllOptions", data)
      // 需要根据新样式的高度 是否修改布局的高度
      //  todo
      this.changeCellSize({
        ...ids,
        height: oldHeight
      })
      // 需要重新初始化更多组件的数据
      if (curOptions.innerElement.toLowerCase().includes("layout")) {
        // 更多按钮初始化跳默认列表页 不用渲染链接
        // this.initMoreData(tmpData.listPageId)
      }
      // 搜索组件不调用rest-classify接口，需要单独监听并处理调用list-search接口
      if (curOptions.componentTypeName === "cxSystemSearch") {
        return
      }
      // 需要触发该组件的更新 updateAll代表分类也要重新请求
      this.$eventBus.$emit(`update-layout-data-eventBus-${ids.container_id}-${ids.rect_id}`, {
        updateAll: true
      })
    },
    changeLocalStyle(style, index, idx) {
      if((style.styleId && style.styleId === this.options.styleId) ||
        (style.options.styleId && style.options.styleId === this.options.styleId) ||
        (style.options.chartOption && style.options.chartOption.styleId && style.options.chartOption.styleId === this.options.chartOption.styleId)){
        // active 状态下点击无效
        return
      }
      if (style.encId) {
        this.changeproductStyle(style, index, idx)
        return
      }
      if (idx) {
        this.activeIndex = this.showLen * (idx - 1) + index
      } else {
        this.activeIndex = index
      }
      let tmpData = JSON.parse(JSON.stringify(style))
      let ids = this.$store.state.states.activeID
      let swiperId = ids.hasOwnProperty("swiperContent_id") ? { ...ids, swiperContent_id: null } : ids
      let curOptions = swiperId ? this.$getOptions(swiperId) : this.$getOptions()
      curOptions = curOptions?.options || curOptions
      if (curOptions?.innerElement === 'cxSwiper3D') {
        let tempCurOptions = JSON.parse(JSON.stringify(curOptions))
        let data = {
          ...ids,
          options: {...tempCurOptions, iframeUrl: tmpData.options?.iframeUrl, styleId: tmpData.options?.styleId}
        }
        this.$store.commit("states/changeActiveID", {...ids}) //清除掉轮播组件的选中状态 swiperContent_id
        this.$store.dispatch(this.request_prefix + "/changeAllOptions", data)
        return
      }
      for (let key in curOptions) {
        if (key.toLowerCase().slice(-2) === "id") {
          tmpData[key] = curOptions[key]
        }
      }
      if (tmpData.options.quoteComponent) {
        this.$emit("changeQuoteStyle", tmpData, curOptions)
        return
      }
      if (curOptions.quoteFrom === "cxSelect") {
        //  tab 引用select样式后，select切换回tab
        //  let activeIndex = curOptions.tabsList.findIndex(item=>item.name === curOptions.value)
        //  activeIndex =  activeIndex===-1 ? 0:activeIndex
        //   tab 引用select样式后，select切换回tab 激活第一个
        let activeIndex = 0
        let newTabList = []
        curOptions.tabsList.forEach(item => {
          newTabList.push({
            name: item.name,
            content: item.name
          })
        })
        if (tmpData.options) {
          tmpData.options.activeIndex = activeIndex
          tmpData.options.singleTabs = false
          tmpData.options.isPageLayoutTabs = curOptions.isPageLayoutTabs
          tmpData.options.tabsList = newTabList
        } else {
          tmpData.activeIndex = activeIndex
          tmpData.singleTabs = false
          tmpData.isPageLayoutTabs = curOptions.isPageLayoutTabs
          tmpData.tabsList = newTabList
        }
      }
      if (tmpData.options) {
        tmpData.options.left = curOptions.left
        tmpData.options.leftType = curOptions.leftType
        tmpData.options.top = curOptions.top
        tmpData.options.topType = curOptions.topType
        tmpData.options.margin = curOptions.margin
        tmpData.options.offset = curOptions.offset
        tmpData.styleId = style.styleId
        tmpData.options.menuName = curOptions.menuName
        tmpData.options.menuIconClass = curOptions.menuIconClass
        tmpData.options.audioUrl = curOptions.audioUrl
        tmpData.options.audioAddress = curOptions.audioAddress
        tmpData.options.audioName = curOptions.audioName
      } else {
        tmpData.left = curOptions.left
        tmpData.leftType = curOptions.leftType
        tmpData.top = curOptions.top
        tmpData.topType = curOptions.topType
        tmpData.margin = curOptions.margin
        tmpData.offset = curOptions.offset
        tmpData.styleId = style.styleId
        tmpData.menuName = curOptions.menuName
        tmpData.menuIconClass = curOptions.menuIconClass
        tmpData.audioUrl = curOptions.audioUrl
        tmpData.audioAddress = curOptions.audioAddress
        tmpData.audioName = curOptions.audioName
      }
      if (curOptions.hasOwnProperty("draggable")) {
        tmpData.options.draggable = curOptions.draggable
      }
      if (curOptions.hasOwnProperty("resizable")) {
        tmpData.options.resizable = curOptions.resizable
      }
      if (curOptions.appId) {
        tmpData.appId = curOptions.appId
        if (tmpData.options) {
          tmpData.options.appId = curOptions.appId
          tmpData.options.myFetchParam = curOptions.myFetchParam
          tmpData.options.moduleId = curOptions.moduleId
          tmpData.options.engineInstanceId = curOptions.engineInstanceId
          tmpData.options.engineInstanceAppId = curOptions.engineInstanceAppId
        }
      }
      if (curOptions.businessId) {
        tmpData.businessId = curOptions.businessId
        if (tmpData.options) {
          tmpData.options.businessId = curOptions.businessId
        }
      }
      tmpData = tmpData.options ? tmpData.options : tmpData
      // 自动布局组件中的属性，切换样式保持不变
      if (curOptions.elementInAutoLayoutId !== undefined) {
        tmpData.elementInAutoLayoutId = curOptions.elementInAutoLayoutId
      }
      // 自动布局组件中的属性，切换样式保持不变
      if (curOptions.path) {
        tmpData.path = curOptions.path
      }
      if (curOptions.menuName === "登录组件") {
        tmpData.activeIndex = curOptions.activeIndex
      }
      if(curOptions.menuName === '抽屉按钮'){
        tmpData.drawerPath = curOptions.drawerPath
      }
      tmpData.pluginName = curOptions.pluginName
      if (curOptions.innerElement === "cxDatePicker") {
        tmpData.zIndex = curOptions.zIndex
        tmpData.display = curOptions.display
        tmpData.relativeComponentId = curOptions.relativeComponentId
      }
      let data = {
        ...ids,
        options: tmpData
      }
      console.log("data", data)
      const changeActiveID = {
        ...ids
      }
      changeActiveID.swiperContent_id = null
      this.$store.commit("states/changeActiveID", changeActiveID) //清除掉轮播组件的选中状态 swiperContent_id
      this.$store.dispatch(this.request_prefix + "/changeAllOptions", data)
      if (curOptions.appId) {
        let nowComp = this.$event.contexts[this.request_prefix][this.$event.getIdsByStrId(ids)]
        nowComp.updateData()
      }
      if (curOptions.businessId) {
        if (this.$store.state[this.request_prefix].page.pluginName?.includes("listPagePlugin")) {
          this.$eventBus.$emit("listPage-component-init", {
            businessId: curOptions.businessId,
            type: curOptions.innerElement
          })
        }
        if (this.$store.state[this.request_prefix].page.pluginName?.includes("detailPagePlugin")) {
          this.$eventBus.$emit("detailPage-component-init", {
            businessId: curOptions.businessId,
            type: curOptions.innerElement
          })
        }
        if (this.$store.state[this.request_prefix].page.pluginName?.includes("subPagePlugin")) {
          this.$eventBus.$emit("subPage-component-init", {
            type: curOptions.innerElement + "_" + curOptions.innerElement
          })
        }
      }
    },
    setMouseEnter(ev) {
      if (hidePreviewStyle(this.options)) {
        this.disablePreview = true
        return
      }
      this.disablePreview = false
      const img = ev.target.children[0],
        width = img.naturalWidth,
        height = img.naturalHeight,
        previewPopover = document.getElementsByClassName("previewPopover")[0],
        baseSize = 616
      this.previewSrc = img.src
      if (width && height) {
        if (width > height) {
          previewPopover.style.width = `${baseSize}px`
          previewPopover.style.height = `${parseInt((height / width) * baseSize)}px`
        } else {
          previewPopover.style.height = `${baseSize}px`
          previewPopover.style.width = `${parseInt((width / height) * baseSize)}px`
        }
      } else {
        previewPopover.style.width = `${baseSize}px`
        previewPopover.style.height = `${baseSize}px`
      }
      previewPopover.style.padding = "8px"
      previewPopover.style.borderRadius = 0
      previewPopover.style.boxShadow = "0px 6px 24px 0px rgba(31, 35, 41, 0.1)"
      previewPopover.style.border = "1px solid rgba(233, 233, 233, 1)"
      this.$refs.previewPopover.updatePopper()
    },
    setMouseOut(ev) {
      if (hidePreviewStyle(this.options)) {
        return
      }
      if (
        !ev.toElement.className.includes("local-img-box") &&
        !ev.toElement.parentElement.className.includes("local-img-box")
      ) {
        this.disablePreview = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.local-styles {
  display: flex;
  flex-wrap: wrap;
  text-align: center;
  gap: 12px;
  p {
    margin-bottom: 0;
    color: var(--textColor);
    line-height: 18px;
    font-size: 13px;
  }
  .local-img-box {
    position: relative;
    height: 85px;
    border-radius: 4px;
    background: var(--editBgColor);
    text-align: center;
    box-sizing: border-box;
    overflow: hidden;
    padding: 8px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    .delete-icon {
      position: absolute;
      display: none;
      bottom: 2px;
      right: 2px;
      border-radius: 2px;
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      background-color: var(--iconHoverBgColor);
      color: var(--iconColor);
    }
    .checked-box{
      position: absolute;
      right: 0;
      top: 0;
      width: 24px;
      height: 24px;
      display: none;
    }
    .icon-checked {
      display: inline-block;
      width: 100%;
      height:100%;
      background-image: url(../../../assets/images/icon-checked.png);
      background-size: 100% 100%;
      position: relative;
      z-index: 2;
    }
    .checked-box:before{
      content: "";
      position: absolute;
      top: 0;
    }
    .checked-box:before {
      left: 0;
      border-top: 12px solid var(--themeColor);
      border-right: 12px solid var(--themeColor);
      border-left: 12px solid transparent;
      border-bottom: 12px solid transparent;
    }
    &:hover {
      .delete-icon {
        display: block;
      }
    }
  }
  .local-style-item {
    width: 108px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 4px;
    &.active {
      .local-img-box {
        box-shadow: 0 0 0 2px var(--themeColor) inset;
        .checked-box {
          display: block;
        }
      }
    }
    &:not(.active) .local-img-box:hover {
      box-shadow: 0 0 0 2px var(--themeColorDisabled) inset;
    }
    &:not(.active) .local-img-box {
      box-shadow: 0 0 0 1px var(--elCollapseItemBorderColor) inset;
    }
  }
  .local-item {
    width: 100%;
    border: none;
    padding: 0;
    cursor: pointer;
  }
}
.local-options-style {
  padding: 16px;
}
.bigScreen .local-options-style {
  padding: 0;
}
.local-options-style .content {
  position: relative;
}
.local-options-style:hover .swiper-button {
  display: block;
}
.swiper-button {
  width: 14px;
  height: 46px;
  line-height: 45px;
  text-align: center;
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
  border-radius: 0px 2px 2px 0px;
  color: var(--subTextColor);
  margin-top: -48px;
  display: none;
}
.swiper-button::after {
  font-size: 12px;
}
.swiper-button-prev {
  left: -14px;
}
.swiper-button-next {
  right: -14px;
}
</style>
